import { Components, Theme } from '@mui/material';

export const MuiButton: Components<Omit<Theme, 'components'>>['MuiButton'] = {
  styleOverrides: {
    root: {
      textTransform: 'capitalize',
      borderRadius: '24px',
      padding: '10px 24px',
    },
  },
};
